import React from 'react';

import DatePicker from 'product_modules/components/DatePicker';
import { InputWithDataTypeProps } from 'product_modules/components/InputWithDataType';

type DateInputProps = Omit<
  InputWithDataTypeProps,
  'visualDataType' | 'visualAttributes' | 'value' | 'onInputChange' | 'onChange'
> & {
  name: string;
  value: string;
  handleInputChange: (value: string) => void;
};

const DateInput = ({ handleInputChange, onBlur, ...props }: DateInputProps) => {
  const handleChange = (value: string | null) => {
    handleInputChange(value || '');
  };

  return (
    <DatePicker
      onChange={(value) => {
        handleChange(value);
        onBlur?.();
      }}
      onInputChange={handleChange}
      dateFormat="MM/DD/YYYY"
      onBlur={onBlur}
      {...props}
    />
  );
};

export default DateInput;
